// Global error handler for Appstle subscription widget errors
(function() {
  const originalErrorHandler = window.onerror;
  const originalUnhandledRejection = window.onunhandledrejection;
  
  // Handle synchronous errors
  window.addEventListener('error', function(event) {
    // Suppress Appstle-related errors that occur during initialization
    if (event.error) {
      const errorMessage = event.error.message || '';
      const errorStack = event.error.stack || '';
      
      if (errorMessage.includes('per_delivery_price') || 
          errorMessage.includes('appstle') ||
          errorMessage.includes('selling_plan') ||
          errorStack.includes('appstle') ||
          errorStack.includes('appstle-subscription')) {
        event.preventDefault();
        event.stopPropagation();
        return true;
      }
    }
    // Allow other errors to propagate normally
    if (originalErrorHandler) {
      return originalErrorHandler.apply(this, arguments);
    }
  }, true);
  
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason) {
      const errorMessage = event.reason.message || String(event.reason) || '';
      const errorStack = event.reason.stack || '';
      
      if (errorMessage.includes('per_delivery_price') || 
          errorMessage.includes('appstle') ||
          errorMessage.includes('selling_plan') ||
          errorStack.includes('appstle') ||
          errorStack.includes('appstle-subscription')) {
        event.preventDefault();
        return true;
      }
    }
    // Allow other rejections to propagate normally
    if (originalUnhandledRejection) {
      return originalUnhandledRejection.apply(this, arguments);
    }
  });
})();

if (!customElements.get('quick-add-modal')) {
    customElements.define(
      'quick-add-modal',
      class QuickAddModal extends ModalDialog {
        constructor() {
          super();
          this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
          this.appstleInitialized = false;
  
          this.addEventListener('product-info:loaded', ({ target }) => {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          });
        }

        connectedCallback() {
          if (this.moved) return;
          this.moved = true;
          const section = this.closest('.shopify-section');
          if (section) {
            this.dataset.section = section.id.replace('shopify-section-', '');
          }
          
          // 移动端：移动到 body；PC 端：保持原位置
          const isMobile = window.innerWidth <= 989;
          if (isMobile) {
            document.body.appendChild(this);
          }
          // PC 端不执行移动，保持原始位置
        }
  
        hide(preventFocus = false) {
          const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if (cartNotification) cartNotification.setActiveElement(this.openedBy);
          
          if (preventFocus) this.openedBy = null;
          
          // Add closing class to trigger CSS animation
          this.classList.add('modal-closing');
          
          // Wait for animation to complete before clearing content and calling super.hide()
          setTimeout(() => {
            this.modalContent.innerHTML = '';
            this.classList.remove('modal-closing');
            this.appstleInitialized = false; // Reset flag when modal closes
          }, 500); // Match the CSS transition duration (--duration-long)
          
          // PC 端：确保移除 overflow-hidden
          const isMobile = window.innerWidth <= 989;
          if (!isMobile) {
            document.body.classList.remove('overflow-hidden');
            document.body.classList.remove('overflow-hidden-desktop');
          }
          
          super.hide();
        }
  
        show(opener) {
          // 关闭所有其他已打开的 quick-add-modal
          const allOpenModals = document.querySelectorAll('quick-add-modal[open]');
          allOpenModals.forEach(modal => {
            if (modal !== this && modal.hasAttribute('open')) {
              modal.hide();
            }
          });
          
          this.setLoadingState(opener, true);

          const productUrl = opener.getAttribute('data-product-url');
          if (!productUrl) {
            this.setLoadingState(opener, false);
            return;
          }

          fetch(productUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.text();
            })
            .then((responseText) => {
              this.processProductResponse(responseText, opener);
            })
            .catch((error) => {
              this.setLoadingState(opener, false);
            });
        }

        setLoadingState(opener, isLoading) {
          if (isLoading) {
            opener.setAttribute('aria-disabled', 'true');
            opener.classList.add('loading');
            const spinner = opener.querySelector('.loading__spinner');
            if (spinner) spinner.classList.remove('hidden');
          } else {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            const spinner = opener.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          }
        }

        processProductResponse(responseText, opener) {
          try {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            
            if (!productElement) {
              this.setLoadingState(opener, false);
              return;
            }

            const productInfoSection = productElement.querySelector('section[id^="ProductInfo-"]');
            const elementToProcess = productInfoSection ? this.createOptimizedProductElement(productElement, productInfoSection) : productElement;

            this.preprocessHTML(elementToProcess);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, elementToProcess.outerHTML);

            this.initializeShopifyComponents();
            this.initializeSubscriptionPriceUpdater();
            this.initializeAppstle();
            this.initializeKlaviyoForModal();
            this.setupVariantChangeHandler();
            super.show(opener);

            // Apply Subscribe/Buy Roast Type intent (list page); run after current stack so variant UI is ready.
            const intent = (opener.getAttribute('data-open-intent') || '').trim();
            if ((intent === 'subscribe' || intent === 'buy') && typeof window.__xbloomApplyRoastTypeIntent === 'function') {
              setTimeout(() => window.__xbloomApplyRoastTypeIntent(this, intent), 0);
            }
            
            // PC 端：移除 overflow-hidden，允许页面滚动
            // 移动端：保留 overflow-hidden，锁定背景滚动
            const isMobile = window.innerWidth <= 989;
            if (!isMobile) {
              document.body.classList.remove('overflow-hidden');
              document.body.classList.remove('overflow-hidden-desktop');
            }
          } catch (error) {
          } finally {
            this.setLoadingState(opener, false);
          }
        }

        createOptimizedProductElement(productElement, productInfoSection) {
          const clonedProductElement = productElement.cloneNode(true);
          const clonedProductInfoSection = clonedProductElement.querySelector('section[id^="ProductInfo-"]');
          if (clonedProductInfoSection) {
            clonedProductElement.innerHTML = '';
            clonedProductElement.appendChild(clonedProductInfoSection);
          }
          return clonedProductElement;
        }

        initializeShopifyComponents() {
          if (window.Shopify?.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }

        initializeSubscriptionPriceUpdater() {
          if (window.SubscriptionPriceUpdater) {
            const productInfo = this.modalContent.querySelector('product-info');
            if (productInfo) {
              // Wait longer to ensure Appstle widget is fully loaded
              setTimeout(() => {
                try {
                  window.SubscriptionPriceUpdater.init(productInfo);
                } catch (e) {
                  console.log('SubscriptionPriceUpdater init error:', e);
                }
              }, 800);
            }
          }
        }

        initializeAppstle() {
          const self = this;
          const modalContent = this.modalContent;
          let retryCount = 0;
          const maxRetries = 3;
          const retryDelay = 1000;
          
          // Helper function to check if all required elements are ready
          const isReadyForAppstle = function() {
            // Check for product form
            const productForm = modalContent.querySelector('.product-form, product-form');
            if (!productForm) return false;
            
            // Check for variant input with a value
            const variantInput = modalContent.querySelector('[name="id"]');
            if (!variantInput || !variantInput.value) return false;
            
            // Check for product info element
            const productInfo = modalContent.querySelector('product-info');
            if (!productInfo) return false;
            
            // Check for Appstle widget element
            const appstleWidget = modalContent.querySelector('.appstle_subscription_wrapper');
            if (!appstleWidget) return false;
            
            // Check if selling plan inputs or options exist (indicates data is loaded)
            const hasSellingPlanData = 
              appstleWidget.querySelector('input[name="selling_plan"]') ||
              appstleWidget.querySelector('.appstle_subscription_wrapper_option') ||
              appstleWidget.querySelector('[data-selling-plan]') ||
              appstleWidget.innerHTML.trim().length > 0;
            
            return hasSellingPlanData;
          };
          
          // Helper function to safely initialize Appstle
          const safeInitAppstle = function() {
            try {
              // Double-check readiness before initialization
              if (!isReadyForAppstle()) {
                return false;
              }
              
              // Verify window.appstle exists and has init function
              if (!window.appstle || typeof window.appstle.init !== 'function') {
                return false;
              }
              
              // Call Appstle init
              window.appstle.init();
              return true;
            } catch (e) {
              // Log error for debugging but don't break the UI
              if (window.console && typeof console.log === 'function') {
                console.log('Appstle initialization error (suppressed):', e.message);
              }
              return false;
            }
          };
          
          // Wait for Appstle widget and all required data
          const waitForAppstle = setInterval(function() {
            // Check if already initialized
            if (self.appstleInitialized) {
              clearInterval(waitForAppstle);
              return;
            }
            
            // Check if all requirements are met
            if (isReadyForAppstle()) {
              clearInterval(waitForAppstle);
              
              // Additional delay to ensure selling plan data is fully loaded
              setTimeout(function() {
                const success = safeInitAppstle();
                
                if (success) {
                  self.appstleInitialized = true;
                } else if (retryCount < maxRetries) {
                  // Retry initialization
                  retryCount++;
                  setTimeout(function() {
                    const retrySuccess = safeInitAppstle();
                    if (retrySuccess) {
                      self.appstleInitialized = true;
                    }
                  }, retryDelay * retryCount);
                }
              }, 800);
            }
          }, 150);
          
          // Stop checking after 12 seconds
          setTimeout(function() {
            clearInterval(waitForAppstle);
          }, 12000);
        }

        setupVariantChangeHandler() {
          const productForm = this.modalContent.querySelector('.product-form');
          const variantInput = this.modalContent.querySelector('[name="id"]');
          const submitButton = this.modalContent.querySelector('.product-form__submit');
          const klaviyoContainer = this.modalContent.querySelector('.klaviyo-product-container');
          
          if (!variantInput || !submitButton || !klaviyoContainer) return;
          
          const toggleButtonVisibility = () => {
            const isDisabled = submitButton.hasAttribute('disabled');
            
            if (isDisabled) {
              submitButton.classList.add('sold-out-hidden');
              klaviyoContainer.style.display = 'block';
            } else {
              submitButton.classList.remove('sold-out-hidden');
              klaviyoContainer.style.display = 'none';
            }
          };
          
          toggleButtonVisibility();
          
          if (productForm) {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
                  toggleButtonVisibility();
                }
              });
            });
            
            observer.observe(submitButton, {
              attributes: true,
              attributeFilter: ['disabled']
            });
          }
          
          variantInput.addEventListener('change', () => {
            setTimeout(toggleButtonVisibility, 100);
          });
        }

        initializeKlaviyoForModal() {
          setTimeout(() => {
            // Class was already changed from klaviyo-bis-trigger to custom-bis-trigger in preprocessHTML
            const klaviyoTrigger = this.modalContent.querySelector('.custom-bis-trigger');
            const productInfo = this.modalContent.querySelector('product-info');
            const variantInput = this.modalContent.querySelector('[name="id"]');
            
            if (!klaviyoTrigger || !productInfo || !variantInput) return;
            
            const productUrl = productInfo.dataset.url;
            if (!productUrl) return;
            
            fetch(productUrl + '.js')
              .then(response => response.json())
              .then(productData => {
                
                klaviyoTrigger.addEventListener('click', (e) => {
                  e.preventDefault();
                  
                  const template = document.getElementById('klaviyo-bis-custom-modal-template');
                  if (!template) {
                    return;
                  }
                  
                  const modalClone = template.content.cloneNode(true);
                  document.body.appendChild(modalClone);
                  
                  const bisCloseOverlay = document.getElementById('klaviyo-bis-close');
                  const bisModal = document.getElementById('klaviyo-bis-modal');
                  const bisForm = document.getElementById('klaviyo-bis-form');
                  const bisMessage = document.getElementById('message');
                  const closeBtn = document.getElementById('close');
                  const productTitle = bisModal.querySelector('[data-product-title]');
                  const variantSelectorContainer = document.getElementById('variant-selector');
                  const variantSelect = document.getElementById('variant-select');
                  
                  if (productTitle) {
                    productTitle.textContent = productData.title;
                  }
                  
                  const currentVariantId = parseInt(variantInput.value);
                  const outOfStockVariants = productData.variants.filter(v => !v.available);
                  
                  // Only show variant selector if there are multiple out-of-stock variants
                  let selectedVariant = null;
                  if (outOfStockVariants.length > 1) {
                    variantSelectorContainer.style.display = 'block';
                    
                    outOfStockVariants.forEach(variant => {
                      const option = document.createElement('option');
                      option.value = variant.id;
                      option.textContent = variant.title;
                      if (variant.id === currentVariantId) {
                        option.selected = true;
                        selectedVariant = variant;
                      }
                      variantSelect.appendChild(option);
                    });
                    
                    // If current variant is not in out-of-stock list, select first out-of-stock variant
                    if (!selectedVariant) {
                      selectedVariant = outOfStockVariants[0];
                      variantSelect.value = selectedVariant.id;
                    }
                    
                    variantSelect.addEventListener('change', () => {
                      const newVariantId = parseInt(variantSelect.value);
                      selectedVariant = productData.variants.find(v => v.id === newVariantId);
                    });
                  } else if (outOfStockVariants.length === 1) {
                    selectedVariant = outOfStockVariants[0];
                  } else {
                    selectedVariant = productData.variants.find(v => v.id === currentVariantId);
                  }
                  
                  const closeBISModal = () => {
                    bisCloseOverlay.remove();
                  };
                  
                  closeBtn.addEventListener('click', closeBISModal);
                  bisCloseOverlay.addEventListener('click', (e) => {
                    if (e.target === bisCloseOverlay) closeBISModal();
                  });
                  
                  bisForm.addEventListener('submit', (e) => {
                    e.preventDefault();
                    
                    const email = bisForm.email.value;
                    const finalVariant = selectedVariant || productData.variants.find(v => v.id === currentVariantId);
                    
                    if (!finalVariant) {
                      bisMessage.style.display = 'block';
                      bisMessage.style.backgroundColor = '#fcd6d7';
                      bisMessage.style.color = '#C72E2F';
                      bisMessage.textContent = 'Variant not found. Please try again.';
                      return;
                    }
                    
                    if (typeof _learnq !== 'undefined') {
                      _learnq.push(['identify', {
                        '$email': email
                      }]);
                      
                      _learnq.push(['track', 'Back in Stock', {
                        'ProductID': productData.id,
                        'VariantID': finalVariant.id,
                        'ProductName': productData.title,
                        'VariantName': finalVariant.title,
                        'ProductURL': window.location.origin + productUrl,
                        'ImageURL': productData.images && productData.images[0] ? productData.images[0] : '',
                        'Price': finalVariant.price / 100
                      }]);
                      
                      bisForm.style.display = 'none';
                      bisMessage.style.display = 'block';
                      bisMessage.style.backgroundColor = '#d3efcd';
                      bisMessage.style.color = '#1B9500';
                      bisMessage.textContent = "You're in! We'll let you know when it's back.";
                      
                      setTimeout(closeBISModal, 2500);
                    } else if (typeof klaviyo !== 'undefined' && klaviyo.push) {
                      klaviyo.push(['identify', {
                        '$email': email
                      }]);
                      
                      klaviyo.push(['track', 'Back in Stock', {
                        'ProductID': productData.id,
                        'VariantID': finalVariant.id,
                        'ProductName': productData.title,
                        'VariantName': finalVariant.title,
                        'ProductURL': window.location.origin + productUrl,
                        'ImageURL': productData.images && productData.images[0] ? productData.images[0] : '',
                        'Price': finalVariant.price / 100
                      }]);
                      
                      bisForm.style.display = 'none';
                      bisMessage.style.display = 'block';
                      bisMessage.style.backgroundColor = '#d3efcd';
                      bisMessage.style.color = '#1B9500';
                      bisMessage.textContent = "You're in! We'll let you know when it's back.";
                      
                      setTimeout(closeBISModal, 2500);
                    } else {
                      bisMessage.style.display = 'block';
                      bisMessage.style.backgroundColor = '#fcd6d7';
                      bisMessage.style.color = '#C72E2F';
                      bisMessage.textContent = 'Service temporarily unavailable. Please try again later.';
                    }
                  });
                });
              })
              .catch(error => {});
          }, 300);
        }
  
        preprocessHTML(element) {
          const productElement = element.tagName === 'PRODUCT-INFO' ? element : element.closest('product-info') || element;
          this.applyColorClasses(productElement);
          
          const preprocessingSteps = [
            () => this.preventDuplicatedIDs(element),
            () => this.removeDOMElements(element),
            () => this.removeGalleryListSemantic(element),
            () => this.updateImageSizes(element),
            () => this.preventVariantURLSwitching(element)
          ];
          
          preprocessingSteps.forEach(step => {
            try {
              step();
            } catch (error) {}
          });
        }

        applyColorClasses(productElement) {
          if (!productElement?.classList) return;
          
          productElement.classList.forEach((classApplied) => {
            if (classApplied.startsWith('color-') || classApplied === 'gradient') {
              this.modalContent.classList.add(classApplied);
            }
          });
        }
  
        preventVariantURLSwitching(element) {
          element.setAttribute('data-update-url', 'false');
        }

        removeDOMElements(element) {
          const selectorsToRemove = [
            'pickup-availability',
            'product-modal',
            'modal-dialog'
          ];

          selectorsToRemove.forEach(selector => {
            const elements = element.querySelectorAll(selector);
            elements.forEach(el => el.remove());
          });
          
          // Remove Klaviyo trigger class to prevent their handler from running in modal
          const klaviyoTriggers = element.querySelectorAll('.klaviyo-bis-trigger');
          klaviyoTriggers.forEach(trigger => {
            trigger.classList.remove('klaviyo-bis-trigger');
            trigger.classList.add('custom-bis-trigger');
          });
        }
  
        preventDuplicatedIDs(element) {
          const productInfoElement = element.closest('product-info');
          const sectionId = element.dataset.section || productInfoElement?.dataset.section;
          
          if (!sectionId) return;

          const oldId = sectionId;
          const newId = `quickadd-${sectionId}`;
          element.innerHTML = element.innerHTML.replaceAll(oldId, newId);
          Array.from(element.attributes).forEach((attribute) => {
            if (attribute.value.includes(oldId)) {
              element.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
            }
          });

          element.dataset.originalSection = sectionId;
        }
  
        removeGalleryListSemantic(element) {
          const galleryList = element.querySelector('[id^="Slider-Gallery"]');
          if (!galleryList) return;

          galleryList.setAttribute('role', 'presentation');
          galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
        }

        updateImageSizes(element) {
          const product = element.querySelector('.product');
          if (!product?.classList.contains('product--columns')) return;

          const mediaImages = product.querySelectorAll('.product__media img');
          if (!mediaImages.length) return;

          const imageSizesMap = {
            'product--medium': '(min-width: 1000px) 605px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)',
            'product--small': '(min-width: 1000px) 495px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)',
            'default': '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)'
          };

          let mediaImageSizes = imageSizesMap.default;
          
          for (const [sizeClass, sizes] of Object.entries(imageSizesMap)) {
            if (sizeClass !== 'default' && product.classList.contains(sizeClass)) {
              mediaImageSizes = sizes;
              break;
            }
          }

          mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
        }

      }
    );
  }

(function() {
  function openBISModalForHandle(handle) {
    if (!handle) return;
    var productUrl = '/products/' + handle;
    fetch(productUrl + '.js')
      .then(function(response) { return response.json(); })
      .then(function(productData) {
        var template = document.getElementById('klaviyo-bis-custom-modal-template');
        if (!template) return;
        var modalClone = template.content.cloneNode(true);
        document.body.appendChild(modalClone);
        var bisCloseOverlay = document.getElementById('klaviyo-bis-close');
        var bisModal = document.getElementById('klaviyo-bis-modal');
        var bisForm = document.getElementById('klaviyo-bis-form');
        var bisMessage = document.getElementById('message');
        var closeBtn = document.getElementById('close');
        var productTitle = bisModal ? bisModal.querySelector('[data-product-title]') : null;
        var variantSelectorContainer = document.getElementById('variant-selector');
        var variantSelect = document.getElementById('variant-select');
        if (productTitle) productTitle.textContent = productData.title;
        var outOfStockVariants = productData.variants.filter(function(v) { return !v.available; });
        var selectedVariant = null;
        if (outOfStockVariants.length > 1) {
          variantSelectorContainer.style.display = 'block';
          outOfStockVariants.forEach(function(variant) {
            var option = document.createElement('option');
            option.value = variant.id;
            option.textContent = variant.title;
            variantSelect.appendChild(option);
          });
          selectedVariant = outOfStockVariants[0];
          variantSelect.value = selectedVariant.id;
          variantSelect.addEventListener('change', function() {
            var newId = parseInt(variantSelect.value, 10);
            selectedVariant = productData.variants.find(function(v) { return v.id === newId; });
          });
        } else if (outOfStockVariants.length === 1) {
          selectedVariant = outOfStockVariants[0];
        } else {
          selectedVariant = productData.variants[0];
        }
        var closeBISModal = function() {
          if (bisCloseOverlay && bisCloseOverlay.parentNode) bisCloseOverlay.remove();
        };
        if (closeBtn) closeBtn.addEventListener('click', closeBISModal);
        bisCloseOverlay.addEventListener('click', function(e) {
          if (e.target === bisCloseOverlay) closeBISModal();
        });
        bisForm.addEventListener('submit', function(e) {
          e.preventDefault();
          var email = bisForm.email.value;
          var finalVariant = selectedVariant || productData.variants[0];
          if (!finalVariant) {
            bisMessage.style.display = 'block';
            bisMessage.style.backgroundColor = '#fcd6d7';
            bisMessage.style.color = '#C72E2F';
            bisMessage.textContent = 'Variant not found. Please try again.';
            return;
          }
          var productFullUrl = window.location.origin + productUrl;
          if (typeof _learnq !== 'undefined') {
            _learnq.push(['identify', { '$email': email }]);
            _learnq.push(['track', 'Back in Stock', {
              'ProductID': productData.id,
              'VariantID': finalVariant.id,
              'ProductName': productData.title,
              'VariantName': finalVariant.title,
              'ProductURL': productFullUrl,
              'ImageURL': (productData.images && productData.images[0]) ? productData.images[0] : '',
              'Price': finalVariant.price / 100
            }]);
            bisForm.style.display = 'none';
            bisMessage.style.display = 'block';
            bisMessage.style.backgroundColor = '#d3efcd';
            bisMessage.style.color = '#1B9500';
            bisMessage.textContent = "You're in! We'll let you know when it's back.";
            setTimeout(closeBISModal, 2500);
          } else if (typeof klaviyo !== 'undefined' && klaviyo.push) {
            klaviyo.push(['identify', { '$email': email }]);
            klaviyo.push(['track', 'Back in Stock', {
              'ProductID': productData.id,
              'VariantID': finalVariant.id,
              'ProductName': productData.title,
              'VariantName': finalVariant.title,
              'ProductURL': productFullUrl,
              'ImageURL': (productData.images && productData.images[0]) ? productData.images[0] : '',
              'Price': finalVariant.price / 100
            }]);
            bisForm.style.display = 'none';
            bisMessage.style.display = 'block';
            bisMessage.style.backgroundColor = '#d3efcd';
            bisMessage.style.color = '#1B9500';
            bisMessage.textContent = "You're in! We'll let you know when it's back.";
            setTimeout(closeBISModal, 2500);
          } else {
            bisMessage.style.display = 'block';
            bisMessage.style.backgroundColor = '#fcd6d7';
            bisMessage.style.color = '#C72E2F';
            bisMessage.textContent = 'Service temporarily unavailable. Please try again later.';
          }
        });
      })
      .catch(function() {});
  }
  window.xbloomOpenBISModalForHandle = openBISModalForHandle;
})();
